export const API_ENDPOINT="workstations"
export const LIMIT=20;